import styled from 'styled-components';
import { Type } from '@spotify-internal/encore-web';

const Ellipsis = styled(Type)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export default Ellipsis;
